<div class="filters-row" [class.column]="layout === 'column'">
  <app-date-range-filter
    *ngIf="fromDateFilter && toDateFilter"
    [fromDateLabel]="fromDateFilter.name || 'From Date'"
    [toDateLabel]="toDateFilter.name || 'To Date'"
    [fromDate]="fromDateValue"
    [toDate]="toDateValue"
    (rangeChange)="onDateRangeChange($event)"
  ></app-date-range-filter>

  <mat-form-field
    *ngFor="let filter of filters?.content"
    class="filter-field"
    [style.display]="shouldShowAsDropdown(filter) ? '' : 'none'"
  >
    <mat-label>{{ filter.name }}</mat-label>

    <mat-select
      #filterSelect
      [multiple]="filter.isMultiSelect"
      [(ngModel)]="selectedValues[filter.key]"
      (openedChange)="onDropdownOpenedChange($event, filterSelect)"
      (selectionChange)="handleSelectionChange(filter)"
    >
      <mat-option *ngIf="shouldEnableSearch(filter)">
        <ngx-mat-select-search
          [formControl]="getSearchControl(filter.key)"
          placeholderLabel="Search..."
          noEntriesFoundLabel="No matching options"
        >
        </ngx-mat-select-search>
      </mat-option>

      <mat-option
        *ngIf="filter.isMultiSelect || filter.showAllOption"
        [value]="'All'"
        (click)="handleSelectionChange(filter, 'All')"
      >
        All
      </mat-option>

      <mat-option
        *ngFor="let option of getFilteredOptions(filter)"
        [value]="option"
        [disabled]="(filter.key === 'end_date' && isEndDateOptionDisabled(option)) || (filter.key === 'end+quarter' && isEndQuarterOptionDisabled(option))"
        (click)="handleSelectionChange(filter, option)"
      >
        {{ option?.viewValue || option }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
